import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import CardBalance from "../../MyAccount/AccountCard/CardBalance";
import useFinalizeManager from "../hooks/useFinalizeManager";
import "./style.scss";
import { useTranslation } from "react-i18next";
import EAButton from "../../shared/Buttons/EAButton";
import EAChip from "../../shared/Chip/EAChip";

interface IProps {
  handleSetPayment: (type: string) => void;
  setInvoiceType: (value: "noInvoice" | "customerInvoice" | "companyInvoice" | "recipientAndPurchaserInvoice") => void;
}

const EcardButton: React.FC<IProps> = ({ handleSetPayment, setInvoiceType }: IProps) => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const isB2B = Boolean(useSelector((state: State) => state.auth.userData.b2bType));
  const { calculateEcard } = useFinalizeManager(() => {});
  const { t } = useTranslation();

  return (
    <>
      {saleConfiguration.ecard_PayByEcard && !isB2B && (
        <>
          <p className="or">{t("lub")}</p>

          <div className="ecard-payment__container">
            <EAChip label={"Alternatywna metoda płatności"} variant="primary" />

            <div className="ecard-payment__container-header">
              <h6 className="text-color-dark">Masz {saleConfiguration.giftCard2Message}?</h6>
              <p className="body-text-small text-color-light-gray">
                Możesz opłacić zamówienie środkami ze swojej karty, bez wracania do standardowej płatności internetowej.
              </p>
            </div>

            <EAButton
              title={`${t("zaplac")} ${saleConfiguration.giftCard3Message}`}
              onClick={() => {
                handleSetPayment("ecard");
                calculateEcard();
                setInvoiceType("noInvoice");
              }}
              variant="outlined"
              fullWidth
            />

            <div className="ecard-payment__balance">
              <p className="body-text-small text-color-dark-gray">{t("dostepne_srodki")}:</p>
              <CardBalance />

              <p className="caption text-color-light-gray">
                Środki zostaną pobrane z przypisanego pakietu po potwierdzeniu płatności.
              </p>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default EcardButton;
